import { unitMapping } from 'lib/style';
import { Color } from 'style/types';

type Props = {
  size?: keyof typeof unitMapping;
  title?: string;
  titleId?: string;
  color?: Color;
  className?: string;
};

export const Vault = ({
  size = 1,
  title,
  titleId,
  color = 'currentColor',
  className,
}: Props) => {
  const fill = color || 'currentColor';

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 16 16"
      fill="none"
      style={{ height: unitMapping[size] }}
      className={className}
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0 0H5.89474V2.52632H2.52632V5.89474H0V0ZM10.1053 0H16V5.89474H13.4737V2.52632H10.1053V0ZM2.52632 10.1053V13.4737H5.89474V16H0V10.1053H2.52632ZM16 10.1053V16H10.1053V13.4737H13.4737V10.1053H16Z"
        fill={fill}
      />
    </svg>
  );
};
